import jQuery from "jquery";
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-pl.js';
import 'jquery-ui/themes/base/datepicker.css';


jQuery(document).ready(() => {
    jQuery('input[rel="date-picker"]').datepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        numberOfMonths: 2
    });
})

/**
 * Inicjuje parę połączonych datepickerów
 * @param {jQuery|string} inputFrom
 * @param {jQuery|string} inputTo
 * @param {object|null|undefined} options
 */
export const initDatepickerPair = function (inputFrom, inputTo, options) {
    options = jQuery.extend({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        numberOfMonths: 2,
    }, options || {});
    var $inputFrom = jQuery(inputFrom);
    var $inputTo = jQuery(inputTo);

    $inputFrom.datepicker(jQuery.extend({}, options, {
        maxDate: $inputTo.val(),
        onClose: function (selectedDate) {
            $inputTo.datepicker("option", "minDate", selectedDate);
            if (_.isFunction(options.onClose)) {
                options.onClose(selectedDate);
            }
        }
    }));
    $inputTo.datepicker(jQuery.extend({}, options, {
        minDate: $inputFrom.val(),
        onClose: function (selectedDate) {
            $inputFrom.datepicker("option", "maxDate", selectedDate);
            if (_.isFunction(options.onClose)) {
                options.onClose(selectedDate);
            }
        }
    }));
};
